import { Badge, Tab, Tabs } from '@mui/material';
import React, { FC, useState } from 'react';
import { ItemSerialized, MediasWrapper } from '../types';
import { useStyles } from './styles';

interface MultimediaTabsProps {
  allowedMedias: MediasWrapper[];
  pluginType: string;
  selectedItems: ItemSerialized[];
  setChangePlugin: (val: string) => void;
}

const getKeyByValue = (tab: string[], value: string) => {
  return Object.keys(tab).find((key: unknown) => tab[key as number] === value);
};

export const MultimediaTabs: FC<MultimediaTabsProps> = ({
  allowedMedias,
  pluginType,
  selectedItems,
  setChangePlugin,
}) => {
  const mediasTypeAllowed = allowedMedias.map(({ type }) => type);
  const pluginIdx = parseInt(
    getKeyByValue(mediasTypeAllowed, pluginType) || '0',
  );
  const classes = useStyles();
  const [value, setValue] = useState(pluginIdx);

  const handleChange = (_: React.ChangeEvent<unknown>, newValue: number) => {
    setValue(newValue);
    setChangePlugin(mediasTypeAllowed[newValue]);
  };

  const selectNumberByPlugin = (type: string) =>
    selectedItems.filter((selectedItem) => selectedItem.pluginType === type);

  return (
    <Tabs
      className={classes.wrapper}
      classes={{
        indicator: classes.indicator,
      }}
      onChange={handleChange}
      orientation="vertical"
      textColor="primary"
      value={value}
    >
      {allowedMedias.map(({ Icon, type, label }) => {
        return (
          <Tab
            classes={{
              root: classes.tab,
            }}
            icon={
              <Badge
                badgeContent={selectNumberByPlugin(type).length}
                color="primary"
                className={classes.tabIcon}
              >
                {<Icon />}
              </Badge>
            }
            key={type}
            label={<span className={classes.tabLabel}>{label}</span>}
          />
        );
      })}
    </Tabs>
  );
};

export { MULTIMEDIA_MANAGER_SEARCH_BLOCK_HEIGHT } from '../MultimediaSearch/styles';
export { MULTIMEDIA_MANAGER_TABS_WIDTH } from './styles';
